let key = {
  // API_URL: "https://digital-hire-backend-dev.cdp360.org",
  // API_URL: "http://192.168.0.17:2053/",
  // API_URL: "http://localhost:2053",
  API_URL: "https://hr-backend.startuphirers.com",
  S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
  // API_URL: "https://hr-backend.cdp360.org/",
  // API_URL: "http://localhost:2053/",
};

export default key;
